export default "__VITE_ASSET__ZVid8mZG__"